/*
Copyright (c) Daybrush
name: svelte-moveable
license: MIT
author: Daybrush
repository: https://github.com/daybrush/moveable/blob/master/packages/svelte-moveable
version: 0.8.11
*/
import { SvelteComponent, init, safe_not_equal, assign, exclude_internal_props } from 'svelte/internal';
import VanillaMoveable, { PROPERTIES, EVENTS, METHODS } from 'moveable';
import { camelize, isUndefined } from '@daybrush/utils';
import { createEventDispatcher, beforeUpdate, tick, onMount, onDestroy } from 'svelte';

/* src/Moveable.svelte generated by Svelte v3.16.7 */

function instance($$self, $$props, $$invalidate) {
  const dispatch = createEventDispatcher();
  let options = {};
  let container;
  let moveable;
  beforeUpdate(() => {
    const props = $$props;
    options = {};
    PROPERTIES.forEach(name => {
      if (name in props) {
        options[name] = props[name];
      }
    });
    container = options.container || $$props.container || document.body;

    if (moveable) {
      tick().then(() => {
        moveable.setState({ ...options,
          container,
          parentElement: container
        });
      });
    }
  });
  onMount(() => {
    moveable = new VanillaMoveable(container || document.body, options);
    EVENTS.forEach(name => {
      const onName = camelize(`on ${name}`);
      moveable.on(name, e => {
        const result = $$props[onName] && $$props[onName](e);
        const result2 = dispatch(name, e);
        return !isUndefined(result) ? result : !isUndefined(result2) ? result2 : undefined;
      });
    });
  });
  onDestroy(() => {
    moveable.destroy();
  });

  function getInstance() {
    return moveable;
  }

  $$self.$set = $$new_props => {
    $$invalidate(5, $$props = assign(assign({}, $$props), exclude_internal_props($$new_props)));
  };

  $$props = exclude_internal_props($$props);
  return [getInstance];
}

class Moveable extends SvelteComponent {
  constructor(options) {
    super();
    init(this, options, instance, null, safe_not_equal, {
      getInstance: 0
    });
  }

  get getInstance() {
    return this.$$.ctx[0];
  }

}

var index = /*#__PURE__*/
(() => {
  const prototype = Moveable.prototype;
  METHODS.forEach(name => {
    prototype[name] = function (...args) {
      const self = this.getInstance();
      const result = self[name](...args);

      if (result === self) {
        return this;
      } else {
        return result;
      }
    };
  });
  return Moveable;
})();

export default index;
//# sourceMappingURL=moveable.esm.js.map
